export class PlantModel {
  public harvestMonths: number = 0;
  public estimatedAvgRadius: number = 0;
  public tcd: number = 0;
  public density: number = 0;
  public volumetry: number = 0;
  public preHarvestDays: number = 0;
  public betweenHarvestNegotiation: number = 0;
}
